import { Input } from "antd";

const CreateContractPeriodeEssai = ({ contract, setContract }) => (
  <section className="contractTrial">
    <h3>Période d’essai</h3>
    <div className="contractTrialGuides">
      {[["1 mois maximum", "2 jours"], ["De 1 à 2 mois", "3 jours"], ["Plus de 2 mois", "5 jours"]].map(([duration, days]) => (
        <div className="contractTrialGuide" key={duration}>
          <span>{duration}</span>
          <p><strong>{days}</strong><span>maximum</span></p>
        </div>
      ))}
    </div>
    <label className="contractTrialField">
      <span>Nombre de jours d’essai</span>
      <Input
        inputMode="numeric"
        onChange={event => setContract(current => ({ ...current, NbJourEssai: event.target.value }))}
        value={contract.NbJourEssai ?? ""}
        placeholder="Ex. 2"
        suffix={<span className="contractTrialUnit">jours</span>}
      />
    </label>
  </section>
);

export default CreateContractPeriodeEssai;
